import React from 'react';
import PropTypes from 'prop-types';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Button from '@/v2/components/atoms/Button';
import Close from '@/v2/components/atoms/Icon/Close';
import Text from '@/v2/components/atoms/Text';
import Loading from '@/v2/components/atoms/Loading';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

import './Hotspot.scss';

const propTypes = {
    data: PropTypes.object,
    activeId: PropTypes.string,
    onFinished: PropTypes.func,
};

const defaultProps = {};

const STATES = {
    idle: 'idle',
    load: 'load',
    start: 'start',
    info: 'info',
    end: 'end',
};

class Hotspot extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeState: STATES.idle,
            activeData: null,
        };

        this.statesActivated = [];
    }

    componentDidUpdate() {
        this.handleActiveId();
    }

    componentWillUnmount() {
        clearTimeouts();
    }

    handleActiveId = () => {
        const { data, activeId } = this.props;
        const { activeData } = this.state;

        if (activeId == null || activeData) return;

        this.changeState(STATES.load, { activeData: data.hotspots.filter((item) => item.id === activeId)[0] });
    };

    videoFinished = () => {
        if (!this.visitedState(STATES.end)) {
            this.changeState(STATES.info);
        }
    };

    reset = () => {
        this.changeState(STATES.idle, { activeData: null });

        this.statesActivated = [];
    };

    close = () => {
        const { onFinished } = this.props;

        this.changeState(STATES.end);

        timeout(() => {
            onFinished();
            this.reset();
        }, 2000);
    };

    visitedState = (state) => this.statesActivated.indexOf(state) !== -1;

    changeState = (state, otherStates) => {
        this.statesActivated.push(state);
        this.setState({ activeState: state, ...otherStates });
    };

    onReady = () => {
        timeout(() => {
            this.changeState(STATES.start);
        }, 170);
    };

    render() {
        const { data } = this.props;
        const { activeState, activeData } = this.state;

        let classFade = '';
        let classCloseAnimate = '';

        if (this.visitedState(STATES.start)) {
            classFade = 'Hotspot__fadeIn';
            classCloseAnimate = 'Hotspot__close--animate-in';
        }

        if (this.visitedState(STATES.end)) {
            classFade = 'Hotspot__fadeOut';
            classCloseAnimate = 'Hotspot__close--animate-out';
        }

        const options = {
            bufferBeforePlay: true,
            autoPlay: true,
            loop: false,
            onReady: this.onReady,
            onFinished: () => {
                this.videoFinished();
            },
        };

        let classTitleAnimation = '';
        let classBodyAnimation = '';

        if (this.visitedState(STATES.end)) {
            classTitleAnimation = 'Hotspot__info--title--animate-out';
            classBodyAnimation = 'Hotspot__info--body--animate-out';
        } else if (this.visitedState(STATES.info)) {
            classTitleAnimation = 'Hotspot__info--title--animate-in';
            classBodyAnimation = 'Hotspot__info--body--animate-in';
        }

        return (
            <>
                {activeState === STATES.load ? <Loading /> : ''}
                {activeState !== STATES.idle ? (
                    <div className="Hotspot">
                        <div className="Hotspot__inner">
                            <VideoSimple src={activeData.video} poster={activeData.poster} options={options} forceRemount />
                            {this.visitedState(STATES.info) ? (
                                <>
                                    <div className="Hotspot__overlay Hotspot__overlay__fadeIn" />
                                    <div className={['Hotspot__close', classCloseAnimate].join(' ')}>
                                        <Button type="button" variant="icon-light" largeHitbox="left" icon={<Close />} onClick={this.close}>
                                            {data.text.cta.close}
                                        </Button>
                                    </div>
                                    <div className="Hotspot__info">
                                        <div className="Hotspot__info--inner">
                                            <div className={['Hotspot__info--title', classTitleAnimation].join(' ')}>
                                                <Text component="h1" className="h2">
                                                    {activeData.text.subject}
                                                </Text>
                                            </div>
                                            <div className={['Hotspot__info--body', classBodyAnimation].join(' ')}>
                                                <Text className="transform-normal">{activeData.text.body}</Text>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className={['Hotspot__fade', classFade].join(' ')} />
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    }
}

Hotspot.propTypes = propTypes;
Hotspot.defaultProps = defaultProps;

export default Hotspot;
